import { useEffect } from 'react'

// evertel
import {
    Row,
    Col,
    Icon,
    Text
} from '@evertel/web/ui'
import { JoinRoomActionButton } from './elements/JoinRoomActionButton'
import { DepartmentController } from '@evertel/department'
import { useService } from '@evertel/di'
import { observer } from 'mobx-react-lite'
import { APIDataRoom } from '@evertel/types'
import { JoinRoomController } from '@evertel/room'

interface ResultProps {
    data: APIDataRoom & { opts: {
        departmentMembersCanJoinAsMember: boolean
        roomMembersCanLeave: boolean
    }}
    innerProps: any
    selectProps: { customProps : {
        joinRoomController: JoinRoomController
        onClose: () => void
        showDept: boolean
        onOpenExtraInfoModal: (id: number) => void
    } }
}

export const RoomListResultItem: React.FC<ResultProps> = observer(({
    data: room,
    innerProps,
    selectProps
}) => {
    const {
        joinRoomController,
        onClose,
        showDept,
        onOpenExtraInfoModal
    } = selectProps.customProps

    const departmentController = useService(DepartmentController, [room.departmentId])

    useEffect(() => {
        if (room.departmentId && showDept) {
            departmentController.init(room.departmentId)
        }
    }, [room?.id, showDept])

    if (!room) return null

    const joinedRooms = joinRoomController.joinedRoomIds
    const joined = !!joinedRooms?.find(r => r === room.id)
    const isPrivate = !room.opts?.departmentMembersCanJoinAsMember
    const isPublic = room.isSearchable

    const roomName = room.name?.trim() ? room.name : ` RoomID:${room.id}`

    return (
        <Row
            className="p-2 border-bottom border-muted hover-light"
            style={{ minHeight: 60 }}
            {...innerProps}>
            <Col
                className="p-0">
                <Row>
                    <Text bold>
                        # {roomName}
                    </Text>
                    {isPrivate &&
                        <Icon name="lock" className="ms-2" />
                    }
                    {isPublic &&
                        <Icon name="bolt" color="primary" className="ms-2" />
                    }
                    {(joined) &&
                        <Text
                            color="success"
                            size="small"
                            bold>
                            <Icon
                                name="check"
                                color="success"
                                className="ms-2"
                            />
                            Joined
                        </Text>
                    }
                </Row>
                <Text
                    size="small"
                    className="ms-3">
                    {room.description || ''}
                </Text>
                {(showDept) &&
                    <Row>
                        <Text
                            bold
                            color="primary"
                            size="small"
                            className="ms-3">
                            {departmentController.department?.name || ''}
                        </Text>
                    </Row>
                }
            </Col>
            <Col
                align="right">
                <JoinRoomActionButton
                    room={room}
                    joinRoomController={joinRoomController}
                    closeModal={onClose}
                    openExtraInfoModal={() => onOpenExtraInfoModal(room.id)}
                />
            </Col>
        </Row>
    )
})
